import { getCookie } from '@/shared/lib/utils/common/getCookie'
import { setCookie } from '@/shared/lib/utils/common/setCookie'

import { AI_UUID_COOKIE, AI_UUID_TTL_DAYS } from '../config/config'

const CREATE_CHAT_ENDPOINT = `/api/ai-bot/ai-chat-create`

const persistChatUuid = (uuid: string): void => {
	const expires = new Date()
	expires.setDate(expires.getDate() + AI_UUID_TTL_DAYS)
	setCookie(AI_UUID_COOKIE, uuid, { expires, path: `/` })
}

export const createAiChatSession = async (): Promise<string> => {
	const response = await fetch(CREATE_CHAT_ENDPOINT, { method: 'POST' })
	if (!response.ok) {
		throw new Error(`Failed to create AI chat session (${response.status})`)
	}

	const json = await response.json()
	const res = typeof json === 'string' ? json : json?.data
	const uuid = res?.data?.uuid

	if (!uuid) {
		throw new Error('AI chat session UUID is missing in response')
	}

	persistChatUuid(uuid)

	return uuid
}

export const getAiChatUuid = async (): Promise<string> => {
	const existing = getCookie(AI_UUID_COOKIE)
	if (existing) {
		return existing
	}

	return await createAiChatSession()
}
